/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarUnscheduledIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarUnscheduledIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarUnscheduledIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarUnscheduledIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZS3BBg': alignSelf,'--mt-2-ZS3BBg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZS3BBg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZS3BBg': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZS3BBg': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZS3BBg': opacity,'--w-10-ZS3BBg': typeof width === 'number' ? `${width}px` : width,'--h-11-ZS3BBg': typeof height === 'number' ? `${height}px` : height,'--f-12-ZS3BBg': fill,'--a-7-ZS3BBg': isAnimated ? animation : "none",'--sd-8-ZS3BBg': isAnimated ? strokeDashoffset : 0,'--sd-9-ZS3BBg': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2CalendarUnscheduledIcon.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_5041_2818)"
 className="views-block"
>
<path
  data-testid="Tysiav2CalendarUnscheduledIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.5 1a1 1 0 00-2 0v1h-1A1.5 1.5 0 000 3.5v9A1.5 1.5 0 001.5 14h11a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0012.5 2h-1V1a1 1 0 10-2 0v1h-5V1zm5.565 5.493a.75.75 0 00-1.13-.987L5.965 8.903l-.933-.934a.75.75 0 10-1.062 1.06l1.5 1.502a.75.75 0 001.095-.037l3.5-4z"
 style={{'--f-12-ZS3BBg': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}